import React from 'react';
import {Stack, Typography} from '@mui/material';

import medicalAppointmentImg from 'presentation/assets/images/medical-appointment.svg';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';

import {ImageContainer, StyledCard} from './styles';

const {emptyState} = translations['pt-br'].privateFlow.myFinancial.paymentsHistory;

export function HistoryEmptyState() {
	const {isMobile} = useMediaQueries();

	return (
		<StyledCard elevation={0}>
			<Stack
				display="flex"
				flexDirection={isMobile ? 'column' : 'row'}
				alignItems="center"
				justifyContent="center">
				<Stack width={isMobile ? '100%' : '400px'} textAlign={isMobile ? 'center' : 'left'}>
					<Typography variant="h6">{emptyState.title}</Typography>
					<Typography color="text.primary" mt={0.5}>
						{emptyState.description}
					</Typography>
				</Stack>
				<ImageContainer sx={{mt: isMobile ? 2 : 0}}>
					<img src={medicalAppointmentImg} alt={emptyState.title} />
				</ImageContainer>
			</Stack>
		</StyledCard>
	);
}
